module.exports = __webpack_public_path__ + "img/avatar1.84151f73.png";